var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.72C8.66663 2.72 2.66662 8.70667 2.66662 16.08C2.66662 22.7467 7.54662 28.28 13.92 29.28L13.92 19.9467L10.5333 19.9467L10.5333 16.08L13.92 16.08L13.92 13.1333C13.92 9.78667 15.9066 7.94667 18.96 7.94667C20.4133 7.94667 21.9333 8.2 21.9333 8.2L21.9333 11.4933L20.2533 11.4933C18.6 11.4933 18.08 12.52 18.08 13.5733L18.08 16.08L21.7866 16.08L21.1866 19.9467L18.08 19.9467L18.08 29.28C21.2219 28.7838 24.0829 27.1807 26.1465 24.7601C28.2102 22.3395 29.3404 19.2609 29.3333 16.08C29.3333 8.70667 23.3333 2.72 16 2.72V2.72Z",
    fill: "#BED6EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c621b90b5150324bbe4a5862f2444a38.svg";
export { ForwardRef as ReactComponent };